import React from 'react';
import { Box } from '@mui/material';
import Progress from '@/components/Progress';

const AppLoader = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', height: '100vh' }}>
      <Box sx={{ m: 'auto', width: 200 }}>
        <Box sx={{ m: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img className='block h-[30px] w-auto' src='/newimages/static/lesaka_logo_horizontal.svg' alt='Kazang'/>
        </Box>
        <Progress />
      </Box>
    </Box>
  );
};

export default AppLoader;
